import { isEmpty } from "lodash";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const SingleEvent = ({ item, animate, scoreAll, addToFavioute }) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  let scoreDisplay =
    scoreAll?.length > 0
      ? scoreAll?.find((obj) => {
          return obj?.eventId == item?.eventId;
        })
      : {};

  return (
    <li
      id="highlightEvent_34730243"
      className={`inplay-${item?.status == "in_play" ? "on" : "off"}`}
    >
      <span className="btn-h2h" id="headToHeadBtn" style={{ display: "none" }}>
        <span id="h2h">H2H</span>
      </span>
      <Link
        id="info"
        to={`/match-detail-sky/${item?.eventId}/${item?.marketId}`}
      >
        <dl>
          <dt>
            {item?.status == "in_play" && (
              <span
                id="streamingIcon"
                className="game-live"
                style={{ display: "flex" }}
              >
                game-live
              </span>
            )}
            <span
              id="lowLiquidityTag"
              className="game-low_liq"
              style={{ display: "none" }}
            >
              Low Liquidity
            </span>
            {item?.hasFancy && (
              <span
                id="fancyBetIcon"
                className="game-fancy in-play"
                style={{ display: "flex" }}
              >
                <pre>in-play</pre>Fancy
              </span>
            )}
            {item?.hasBookmaker && (
              <span
                id="bookMakerIcon"
                className="game-bookmaker in-play"
                style={{ display: "flex" }}
              >
                <pre>in-play</pre>BookMaker
              </span>
            )}
            {item?.hasSportBook && (
              <span id="feedingSiteIcon" className="game-sportsbook">
                Premium {item?.gameType}
              </span>
            )}

            {item?.status == "in_play" ? (
              <span id="dateTimeInfo" className="time">
                In-Play
              </span>
            ) : (
              <span id="dateTimeInfo" className="time">
                {isDateToday(item?.eventDateTime)
                  ? moment(item?.eventDateTime).format("HH:MM")
                  : moment(item?.eventDateTime).format("DD/MM HH:MM")}
              </span>
            )}
            {item?.gameType == "soccer" &&
              (item?.eventName?.includes(" SRL T20 ") ||
                item?.eventName?.includes(" T10 ")) && (
                <span id="sportsBookEIcon_137" className="game-E">
                  <i />
                  e-Soccer
                </span>
              )}
            {item?.gameType == "cricket" &&
              (item?.eventName?.includes(" SRL T20 ") ||
                item?.eventName?.includes(" T10 ")) && (
                <span id="sportsBookEIcon_4" className="game-E">
                  <i />
                  Cricket
                </span>
              )}
            {item?.gameType == "tennis" &&
              (item?.eventName?.includes(" SRL T20 ") ||
                item?.eventName?.includes(" T10 ")) && (
                <span id="sportsBookEIcon_2" className="game-E">
                  <i />
                  Tennis
                </span>
              )}
          </dt>
          <dd id="eventName">
            {item?.eventName?.split(" v ")[0]}{" "}
            <span>{isEmpty(scoreDisplay) ? "v" : scoreDisplay?.score}</span>{" "}
            {item?.eventName?.split(" v ")[1]}
          </dd>
        </dl>
      </Link>
      <a
        href="#"
        onClick={(e) => {
          if (item?.runners?.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            addToFavioute(
              item?.eventId,
              "Match Odds",
              item?.marketId,
              item?.eventType
            );
          }
        }}
        id="multiMarketPin"
        className={`pin-${animate ? "on" : "off"}`}
      />
    </li>
  );
};

export default SingleEvent;
